module.exports = __webpack_public_path__ + "img/gouwu.45b565f0.png";